/**
 * Map SendMessagePage compose payload → bulk / segment-push API body fields
 * (template_id, variable_values, schedule, media). Does not include customer_ids.
 */
export function buildBulkMessagePayload({ templateId, messagePayload }) {
  const uiSendMode = messagePayload?.sendMode || 'send_now';
  const schedule = messagePayload?.schedule;
  const sendingMode = uiSendMode === 'scheduled' ? 'schedule_once' : uiSendMode;

  let variable_values = [];
  if (messagePayload?.schema && messagePayload?.values) {
    variable_values = messagePayload.schema.variable_order.map(
      (varId) => messagePayload.values[varId] || '',
    );
  }

  const payload = {
    template_id: templateId,
    variable_values,
    sending_mode: sendingMode,
    stop_on_reply: schedule?.stop_on_reply === true,
  };

  if (
    Array.isArray(messagePayload?.contact_numbers) &&
    messagePayload.contact_numbers.length > 0
  ) {
    payload.contact_numbers = messagePayload.contact_numbers;
  } else if (messagePayload?.contact_number) {
    payload.contact_numbers = [messagePayload.contact_number];
  }

  if (sendingMode === 'schedule_once' && schedule) {
    payload.scheduled_date_time = schedule.scheduled_date_time;
    payload.stop_on_reply = schedule.stop_on_reply === true;
    if (schedule.name) payload.name = schedule.name;
  } else if (sendingMode === 'interval' && schedule) {
    payload.interval_value = schedule.interval_value;
    payload.interval_unit = schedule.interval_unit;
    payload.start_date = schedule.start_date;
    payload.stop_on_reply = schedule.stop_on_reply === true;
    if (schedule.end_date) payload.end_date = schedule.end_date;
    if (schedule.max_attempts != null) {
      payload.max_attempts = schedule.max_attempts;
    }
    if (schedule.name) payload.name = schedule.name;
  }

  if (messagePayload?.mediaType && messagePayload?.base64Data) {
    if (messagePayload.mediaType === 'document') {
      payload.document_base64 = messagePayload.base64Data;
      payload.document_filename = messagePayload.filename;
    } else if (messagePayload.mediaType === 'image') {
      payload.image_base64 = messagePayload.base64Data;
      payload.image_filename = messagePayload.filename;
    } else if (messagePayload.mediaType === 'video') {
      payload.video_base64 = messagePayload.base64Data;
      payload.video_filename = messagePayload.filename;
    }
  }

  if (
    messagePayload?.carouselMedia &&
    Object.keys(messagePayload.carouselMedia).length > 0
  ) {
    const sortedKeys = Object.keys(messagePayload.carouselMedia).sort(
      (a, b) => parseInt(a) - parseInt(b),
    );
    payload.card_images = sortedKeys.map(
      (key) => messagePayload.carouselMedia[key].base64Data,
    );
  }

  return payload;
}
